export type ClassesRostersView = 'classes' | 'no-classes' | 'no-students';

/**
 * 'classes'     -> at least one class (show the grid)
 * 'no-classes'  -> students enrolled at the site(s) but no classes yet
 * 'no-students' -> no students enrolled at all
 */
export function getClassesRostersView(classCount: number, studentCount: number): ClassesRostersView {
  if (classCount > 0) return 'classes';
  if (studentCount > 0) return 'no-classes';
  return 'no-students';
}
